import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";

import { Table, Card, CardBody, CardTitle, Collapse, Row } from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";

// Componentes
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import IconButton from "../../../components/Buttons/IconButton";
import Pagination from "../../../components/Paginationv3";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
import DuplicateForm from "./duplicateForm";

// Services
import { deleteForm, getAllForms } from "../../../utils/services/rsvp";

// Utils
import { formatDateTime } from "../../../utils/helpers/files/formatDate";
import useDebounce from "../../../utils/hooks/useDebounce";

// moment
import moment from "moment";

function Rsvp(props) {
  const { setModalView } = props;
  // State de pesquisa
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);

  // State de paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // State de deleção
  const [confirm_alert, setConfirmAlert] = useState(false);
  const [idDelete, setIdDelete] = useState("");
  const [success_dlg, setSuccessDlg] = useState(false);

  // State de collapse mobile
  const [isOpen, setIsOpen] = useState(false);

  // State de loading
  const [isLoading, setIsLoading] = useState(false);

  // State de duplicar
  const [isOpenDuplicate, setIsOpenDuplicate] = useState(false);
  const [selectedForm, setSelectedForm] = useState([]);

  // State de dados
  const [forms, setForms] = useState([]);

  // Busca os formulários do evento
  const allForms = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getAllForms({
        eventId: props.eventId,
        offset: currentIndex,
        limit: itemsPerPage,
        search: debouncedSearch,
      });
      if (response) {
        setCountData(response.data.total);
        setForms(response.data.forms || []);
      }
    } catch {
      toast.error("Erro ao carregar formulários.");
    } finally {
      setIsLoading(false);
    }
  }, [props.eventId, currentIndex, itemsPerPage, debouncedSearch]);

  // Deleta o formulário selecionado
  const deleteSelectedForm = async () => {
    try {
      await deleteForm({ id: idDelete });
      setSuccessDlg(true);
      setConfirmAlert(false);
      await allForms();
    } catch {
      toast.error("Erro ao deletar formulário.");
    }
  };

  // Reseta a paginação ao pesquisar
  const handleSearch = (value) => {
    setSearch(value);
    setCurrentIndex(1);
  };

  useEffect(() => {
    allForms();
  }, [allForms]);

  return (
    <div>
      <DuplicateForm
        isOpen={isOpenDuplicate}
        toggle={() => setIsOpenDuplicate(false)}
        selectedForm={selectedForm}
        updateList={allForms}
      />
      {confirm_alert ? (
        <SweetAlert
          title="Deseja deletar esse formulário?"
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => deleteSelectedForm()}
          onCancel={() => setConfirmAlert(false)}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      ) : null}
      {success_dlg ? (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => setSuccessDlg(false)}
        >
          Formulário deletado com sucesso
        </SweetAlert>
      ) : null}
      <Card>
        <CardBody>
          <CardTitle>Formulário Dinâmico</CardTitle>
          <div className="d-flex w-100 justify-content-between mb-2">
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                <Row className="mobile-btns-top">
                  <div onClick={() => props.setStep("_b")}>
                    Criar Formulário
                  </div>
                </Row>
              </Collapse>
            </div>
            <div className="header-btns-container">
              <ActionButtonRounded
                title="Criar Formulário"
                onClick={() => props.setStep("_b")}
              />
            </div>
          </div>

          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>Data de criação</th>
                  <th>Última atualização</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <LoadingSkelentonTable lines={10} cols={5} />
                ) : (
                  forms.length > 0 &&
                  forms.map((form) => (
                    <tr key={form.id}>
                      <td>{form.id}</td>
                      <td>{form.description}</td>
                      <td>
                        {moment.utc(form.createdAt).format("DD/MM/YYYY HH:mm")}
                      </td>
                      <td>
                        {moment.utc(form.updatedAt).format("DD/MM/YYYY HH:mm")}
                      </td>
                      <td>
                        <i
                          className="mdi mdi-pencil"
                          onClick={() => {
                            props.setSelectedForm(form);
                            props.setStep("_c");
                          }}
                          style={{
                            color: "green",
                            fontSize: 17,
                            cursor: "pointer",
                          }}
                        />{" "}
                        <IconButton
                          title="Duplicar formulário"
                          className="mdi mdi-content-duplicate"
                          color="gray"
                          onClick={() => {
                            setSelectedForm(form);
                            setIsOpenDuplicate(true);
                          }}
                          action={"C"}
                        />{" "}
                        <i
                          className="mdi mdi-eye"
                          onClick={() => {
                            props.setSelectedForm(form);
                            setModalView(true);
                          }}
                          style={{
                            color: "blue",
                            fontSize: 17,
                            cursor: "pointer",
                          }}
                        />{" "}
                        <DeleteButton
                          onClick={() => {
                            setIdDelete(form.id);
                            setConfirmAlert(true);
                          }}
                          color="red"
                          fontSize={17}
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div className="bottom-navigation" style={{ justifyContent: "end" }}>
        <Pagination
          data={[]}
          search={debouncedSearch}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Rsvp);
